export default "__VITE_PUBLIC_ASSET__f9d6fb13__"